module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-5.0f6492f7.JPG";